import { Component } from '@angular/core';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent {

	constructor(
		private sideMenuService: SideMenuService,
	) { }

	ngOnInit() {
		this.sideMenuService.hide();
	}

}
